export default "/assets/site/images/foci.jpg?6b24627bcedd74a99c1df6cf0cfc1c87";